// Note: vue2-google-maps is not compatible with Vue 3
// Consider using @fawmi/vue-google-maps or vue3-google-map instead
// For now, this is a placeholder that provides the API key

const apiKey = 'AIzaSyDWfyZ968kdYxx_tGqXMG-Rvo2pqO0FPqg'

export default defineNuxtPlugin((nuxtApp) => {
    // TODO: Replace with Vue 3 compatible Google Maps library
    // import VueGoogleMaps from '@fawmi/vue-google-maps'
    // nuxtApp.vueApp.use(VueGoogleMaps, {
    //     load: {
    //         key: apiKey,
    //         libraries: 'places'
    //     }
    // })

    return {
        provide: {
            googleApiKey: apiKey
        }
    }
})
